'use client'

import React, { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/navigation'
import RecipeImportModal from './RecipeImportModal'

interface RecipeAddSubmenuProps {
  buttonLabel?: string
  className?: string
}

export function RecipeAddSubmenu({
  buttonLabel = 'Add Recipe',
  className = '',
}: RecipeAddSubmenuProps) {
  const router = useRouter()
  const [open, setOpen] = useState(false)
  const [importModalOpen, setImportModalOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false)
      }
    }

    if (open) {
      document.addEventListener('click', handleClickOutside)
    }

    return () => document.removeEventListener('click', handleClickOutside)
  }, [open])

  const handleImportSuccess = (scrapedData: unknown) => {
    sessionStorage.setItem('importedRecipeData', JSON.stringify(scrapedData))
    router.push('/recipes/add?imported=true')
  }

  return (
    <>
      <div ref={containerRef} className={`relative inline-block ${className}`}>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            setOpen((prev) => !prev)
          }}
          className="flex h-[43px] items-center justify-center rounded-full bg-[#85C349] px-8 text-base text-white hover:bg-[#75B339]"
        >
          {buttonLabel}
        </button>

        {open && (
          <div
            className="absolute left-1/2 top-full z-50 mt-2 min-w-[200px] -translate-x-1/2 rounded-lg border border-gray-200 bg-white shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => {
                setOpen(false)
                router.push('/recipes/add')
              }}
              className="flex w-full items-center gap-2 border-b border-gray-100 px-4 py-3 text-left text-sm hover:bg-gray-100"
            >
              <span>✏️</span>
              Type it in
            </button>
            <button
              type="button"
              onClick={() => {
                setOpen(false)
                setImportModalOpen(true)
              }}
              className="flex w-full items-center gap-2 px-4 py-3 text-left text-sm hover:bg-gray-100"
            >
              <span>🔗</span>
              Paste a link
            </button>
          </div>
        )}
      </div>

      <RecipeImportModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onSuccess={handleImportSuccess}
      />
    </>
  )
}
